var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnbanned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "unbanned") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "unbanned",
    stroke: "none",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,3.43994 C12.45,3.43994 9.25,4.90994 6.96,7.27994 L3.44,3.75994 L3.44,13.4999 L13.18,13.4999 L12.29,12.6099 L9.8,10.1199 C11.35,8.46994 13.56,7.43994 16,7.43994 C20.71,7.43994 24.55,11.2799 24.55,15.9999 C24.55,17.8299 23.97,19.5399 22.97,20.9299 L16.95,14.9099 L15.94,15.9299 L14.13,17.7399 L14.19,17.8099 L19.96,23.5699 C18.77,24.1999 17.43,24.5499 16,24.5499 C13.64,24.5499 11.51,23.5899 9.96,22.0399 L7.13,24.8699 C9.4,27.1499 12.53,28.5499 16,28.5499 C22.93,28.5499 28.55,22.9299 28.55,15.9999 C28.55,9.06994 22.93,3.43994 16,3.43994 Z",
    id: "Path",
    fill: "#FF9D00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnbanned);
export default __webpack_public_path__ + "static/media/unbanned.fd11d900151760761c56a18bfd4204be.svg";
export { ForwardRef as ReactComponent };